import LABEL from '../../../business-const/Label/Label'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridContainerS0,
    GridItem2,
    GridItem3,
    GridItem5,
    GridItem6,
    GridItem7,
} from '../../../business-components/Grid/Grid'



const ConsorcioSimulacaoReportLabelCampo = ({ label }) => {

    return (
        <h5
            className='mt-0 text-muted'
        >
            {label}
        </h5>
    )
}

/*const ConsorcioSimulacaoReportLabelPerc = () => {

    return (
        <div
            className='mt-6 text-muted'
        >
            {LABEL.perc}
        </div>
    )
}*/

const ConsorcioSimulacaoReportLabelVezes = () => {

    return (
        <div
            className='mt--1'
        >
            {LABEL.vezes}
        </div>
    )
}

const ConsorcioSimulacaoReportCampoTexto = ({ texto }) => {

    return (
        <h6
            className='mt-0'
        >
            {texto}
        </h6>
    )
}

const ConsorcioSimulacaoReportCampoValor = ({ valor }) => {

    return (
        <h6
            className='mt-0'
        >
            {formataValor(round(valor, 2), 2)}
        </h6>
    )
}

const ConsorcioSimulacaoReportCampoNumero = ({ numero }) => {

    return (
        <h6
            className='mt-0'
        >
            {numero}
        </h6>
    )
}

const ConsorcioSimulacaoReportCampoPerc = ({ perc, report }) => {

    return (
        <h6
            className={'mt-0'}
        >
            {formataPerc(perc, 2)}
        </h6>
    )
}

/*const ConsorcioSimulacaoReportCampoPercInput = ({ perc, casasDecimais }) => {

    return (
        <h6
            className='mt-0'
        >
            {formataPerc(perc, casasDecimais ? casasDecimais : 2)}
        </h6>
    )
}*/



export const ConsorcioSimulacaoReport = ({ className, label, texto, numero, valor, perc, opcional }) => {

    return (
        !opcional || (opcional && (texto || numero || valor || perc))
            ?
                <GridContainer
                    className={className}
                >
                    {label && (
                        <GridItem5>
                            <ConsorcioSimulacaoReportLabelCampo
                                label={label}
                            />
                        </GridItem5>
                    )}

                    <GridItem6>
                        {texto && (
                            <ConsorcioSimulacaoReportCampoTexto
                                texto={texto}
                            />
                        )}
                        {numero && (
                            <ConsorcioSimulacaoReportCampoNumero
                                numero={numero}
                            />
                        )}
                        {valor && (
                            <ConsorcioSimulacaoReportCampoValor
                                valor={valor}
                            />
                        )}
                        {(perc || perc === 0) && (
                            <ConsorcioSimulacaoReportCampoPerc
                                perc={perc}
                            />
                        )}
                    </GridItem6>
                </GridContainer>
            :
                ''
    )
}

export const ConsorcioSimulacaoReportNumeroValor = ({ label, numero, valor }) => {

    return (
        <GridContainer>
            <GridItem5>
                <ConsorcioSimulacaoReportLabelCampo
                    label={label}
                />
            </GridItem5>

            <GridItem6>
                <GridContainer>
                    <GridItem3>
                        <GridContainerS0>
                            <GridItem7>
                                <ConsorcioSimulacaoReportCampoNumero
                                    numero={numero}
                                />
                            </GridItem7>
        
                            <GridItem5>
                                <ConsorcioSimulacaoReportLabelVezes/>
                            </GridItem5>
                        </GridContainerS0>
                    </GridItem3>
                    
                    <GridItem6>
                        <ConsorcioSimulacaoReportCampoValor
                            valor={valor}
                        /> 
                    </GridItem6>
                </GridContainer>
            </GridItem6>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoReportPercValor = ({ label, perc, valor }) => {

    return (
        <GridContainer>
            <GridItem5>
                <ConsorcioSimulacaoReportLabelCampo
                    label={label}
                />
            </GridItem5>

            <GridItem6>
                <GridContainer>
                    <GridItem2>
                        <ConsorcioSimulacaoReportCampoPerc
                            perc={perc}
                        />
                    </GridItem2>
                    
                    <GridItem6>
                        <ConsorcioSimulacaoReportCampoValor
                            valor={valor}
                        /> 
                    </GridItem6>
                </GridContainer>
            </GridItem6>
        </GridContainer>
    )
}